<script>
	export default {
		name: 'TypeExecuter',
		methods: {
			// memo
			// these targets never call this plugin in this application
			// 
			// target
			// ------------
			// new Number()
			// new String()
			// new Map()
			// new Set()
			isUndefined(target) {
				if(typeof target == 'undefined') { return true }
				else { return false }
			},
			isFalse(target) {
				// target			->	!target		->	result
				// ------------			------------	------------
				// null				->	true		->	true
				// undefined		->	true		->	true
				// NaN				->	true		->	true
				// false			->	true		->	true	
				// 0				->	true		->	*false
				// ''				->	true		->	*false
				// true				->	false		->	false
				// {key: 'value'}	->	false		->	false
				// ['array']		->	false		->	false
				// 1234				->	false		->	false
				// 'abcd'			->	false		->	false
				// function () {}	->	false		->	false
				// () => {}			->	false		->	false
				// function* () {} 	->	false		->	false
				// Symbol()			->	false		->	false
				if(target) { return false }

				if(typeof target == 'number' && target == 0) { return false }

				if(typeof target == 'string' && target == '') { return false }

				return true
			},
			isEmpty(target) {
				// target			->	result
				// ------------		------------
				// isFalse			->	true
				// []				->	true
				// {}				->	true
				// 0				->	true
				// ''				->	true
				const self_ = this;

				if(self_.isFalse(target)) { return true }

				if(target instanceof Date) { return false }

				if(target instanceof Array) { // empty array
					if(target.length == 0) { 
						return true
					} else { return false }
				}

				if(typeof target == 'object') { // empty object
					if(Object.keys(target).length == 0) {
						return true
					} else { return false }
				}

				if(typeof target == 'number' && target == 0) {
					return true
				} else if(typeof target == 'string' && target == '') {
					return true
				} else { return false }
			},
			isNumber(target) {
				if((typeof target === 'number') && (isFinite(target))) {
					return true
				} else { return false }
			},
			isBoolean(target) { // this function returns FALSE for empty array
				if(typeof(target) == 'boolean') { 
					return true
				} else { return false }
			},
			isArray(target) { // this function returns FALSE for empty array
				if(target instanceof Array) {
					if(target.length == 0) { // empty array
						return false
					} else {
						return true
					}
				} else { return false }
			},
			isObject(target) { // this function returns FALSE for empty object
				// target			->	type of target	->	result
				// ------------			------------		------------
				// {key: 'value'}	->	object			->	true
				// {}				-> 	object			->  *false // check length of key array 
				// null				->	object			->	*false // call isNull first
				// ['array']		->	object			->	*false // call isArray first
				// new Number()		->	object			->	*false // never be called by this target
				// new String()		->	object			->	*false // never be called by this target
				// new Map()		->	object			->	*false // never be called by this target
				// new Set()		->	object			->	*false // never be called by this target
				// undefined		->	undefined		->	false
				// true / false		->	boolean			->	false
				// NaN				->	number			->	false
				// 1234				->	number			->	false
				// 'abcd'			->	string			->	false
				// ''				->	string			->	false
				// function () {}	->	function		->	false
				// () => {}			->	function		->	false
				// function* () {} 	->	function		->	false
				// Symbol()			->	symbol			->	false
				const self_ = this;
			
				if((typeof target) == 'object') {
					if((target instanceof Array) || (self_.isFalse(target))) { // array or null
						return false
					} else {
						if(Object.keys(target).length == 0) { // empty object
							return false 
						} else { return true }
					}
				} else { return false }
			},
			isResponsive(target) { // responsive object must have both web and mobile property
				const self_ = this;

				if(!self_.isObject(target) || self_.isEmpty(target)) { return false }
				else { 
					if(!self_.isUndefined(target.web) && !self_.isUndefined(target.mobile)) {
						return true
					} else { return false }
				}
			}
		}
	}
</script>